
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Innovacrystacabsinpune() {



    const cardData =
    {
        keyword: 'Innova Crysta Cabs in Pune',
        heading: 'Meghana Cab : Innova Crysta Cabs in Pune',
        headingDescription: 'Meghana Cab offers Innova Crysta Cabs in Pune, delivering a premium, spacious, and comfortable travel experience for every occasion—whether it’s airport transfers, city sightseeing, corporate trips, family outings, or outstation journeys. Our Innova Crysta vehicles are meticulously maintained, featuring plush leather interiors, ample legroom, generous luggage space, and advanced safety features to ensure a luxurious ride.',


        top: 'Top Places to Visit in Pune with Meghana Cab',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Built in 1732 by the Peshwas, Shaniwar Wada is an iconic symbol of Pune’s Maratha legacy. Once a grand palace complex with seven stories and ornate halls, it was tragically gutted by a fire in 1828. Today, its massive gates, fortified walls, lotus-shaped fountains, and sprawling gardens continue to attract history lovers. Legends of palace intrigue and haunting folklore make it one of Pune’s most visited historical sites. The evening light-and-sound show offers a captivating audio-visual journey into Maratha history."
  },
  {
    "title": "Aga Khan Palace",
    "description": "This majestic palace was built in 1892 by Sultan Aga Khan III and holds a revered place in India’s freedom struggle. It served as a place of incarceration for Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai during the Quit India Movement. The palace, surrounded by serene gardens, now functions as a memorial and museum, housing Gandhi’s belongings, rare photographs, and his ashes. It is a peaceful oasis that blends architecture, history, and patriotism."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Located about 35 km southwest of Pune, Sinhagad Fort is a hilltop military outpost famed for the 1670 Battle of Sinhagad, where Maratha warrior Tanaji Malusare displayed unparalleled bravery. Trekkers flock to this fort year-round for its rugged paths, panoramic views, and rustic food stalls serving local delicacies like 'pithla-bhakri'. The ruins of gates, watchtowers, and memorials transport visitors back to the era of valor and strategy. Monsoon is an especially magical time to visit."
  },
  {
    "title": "Osho International Meditation Resort",
    "description": "Spread across 28 acres in Koregaon Park, the Osho Ashram is one of the world’s largest meditation centers. It blends Zen-inspired architecture with lush gardens and modern amenities. The resort offers dynamic meditations, healing therapies, creative workshops, and wellness programs. Visitors from over 100 countries come here for personal transformation, silence, and rejuvenation. It’s a unique sanctuary where mindfulness meets luxury, nestled within Pune’s urban heart."
  },
  {
    "title": "Dagdusheth Halwai Ganapati Temple",
    "description": "Dedicated to Lord Ganesha, this 130-year-old temple is a spiritual landmark in Pune’s Budhwar Peth area. The temple’s 7.5-foot-tall idol is adorned with over 40 kg of gold and is revered by politicians, celebrities, and millions of devotees. It becomes the epicenter of the city’s Ganesh Chaturthi celebrations, drawing lakhs of people. The temple is known for its vibrant atmosphere, intricate decorations, and a strong connection to Pune’s cultural identity."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "An 8th-century rock-cut temple dedicated to Lord Shiva, Pataleshwar is carved from a single basalt rock and features a sanctum with a Shiva lingam, a circular Nandi mandapa, and intricately carved pillars. Located on busy Jangli Maharaj Road, this monument offers a peaceful spiritual retreat amidst urban life. It stands as a testament to ancient Indian architecture and artistry and is a lesser-known gem in Pune’s heritage circuit."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "This unique museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing the everyday life of India’s past. From ornate doors and miniature paintings to musical instruments, sculptures, and antique utensils, the exhibits reflect the richness of Indian craftsmanship. The highlight is the reconstructed 'Mastani Mahal', representing the royal elegance of the Maratha court. Audio guides and themed galleries make this a must-visit cultural destination."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Rising 2,100 feet above sea level, Parvati Hill offers a scenic trek with 103 stone steps leading to a hilltop complex of Peshwa-era temples. The Parvati Temple, dedicated to Goddess Parvati, offers panoramic views of Pune. A small museum here showcases artifacts from the Peshwa dynasty. The spot is perfect for early morning visits, photography, and spiritual reflection—especially during sunrise and winter months."
  },
  {
    "title": "Rajiv Gandhi Zoological Park (Katraj Zoo)",
    "description": "Spread across 130 acres on the southern outskirts of Pune, this well-maintained zoological park includes a snake park, zoo, and lake. It houses tigers, leopards, elephants, deer, crocodiles, and a wide variety of birds. It’s an educational hotspot for children and families, offering nature trails, animal adoption programs, and boating facilities. The zoo is a perfect mix of wildlife conservation and recreation."
  },
  {
    "title": "Shinde Chhatri",
    "description": "Located in Wanowrie, Shinde Chhatri is a stunning 18th-century memorial dedicated to Maratha military leader Mahadji Shinde. The structure features elaborate Rajasthani-style domes, colorful stained-glass windows, and an atmosphere of serene grandeur. The adjoining Shiva temple and the samadhi (final resting place) of Shinde add to the historical depth. It’s one of Pune’s lesser-known heritage sites, rich in architecture and historical importance."
  }
],

"services": [
  {
    "name": "Innova Crysta Cabs Pune",
    "description": "Travel in style and comfort with our Innova Crysta cabs in Pune. Ideal for city travel, outstation trips, and group outings, our well-maintained fleet offers a premium travel experience with spacious seating, excellent legroom, and smooth suspension for all kinds of journeys."
  },
  {
    "name": "Innova Crysta Taxi Service Pune",
    "description": "Our Innova Crysta taxi service in Pune provides reliable and professional transportation for every need. Whether it’s local commutes, business travel, or family trips, enjoy clean vehicles, experienced chauffeurs, and flexible packages designed to fit your schedule."
  },
  {
    "name": "Affordable Innova Crysta Pune",
    "description": "Looking for premium comfort at affordable rates? Our affordable Innova Crysta rental service in Pune offers luxury travel without the luxury price. Get cost-effective packages for daily rentals, outstation tours, or airport transfers without compromising on quality."
  },
  {
    "name": "Chauffeur Driven Innova Crysta Pune",
    "description": "Experience luxury on the road with our chauffeur-driven Innova Crysta service in Pune. Our trained drivers ensure safe, punctual, and courteous service, making your travel worry-free whether you’re heading to meetings, weddings, or family functions."
  },
  {
    "name": "Online Booking Innova Crysta Pune",
    "description": "Book your Innova Crysta online in Pune with ease. Our seamless digital platform allows instant cab reservations with transparent pricing, route customization, and real-time confirmations—ensuring a smooth start to every journey."
  },
  {
    "name": "Family Innova Crysta Taxi Pune",
    "description": "Travel comfortably with your family in a spacious Innova Crysta taxi from Pune. With flexible seating arrangements, AC comfort, and ample luggage space, this cab is perfect for family holidays, Pune Darshan, or outstation tours with kids and elders."
  },
  {
    "name": "Corporate Innova Crysta Cab Pune",
    "description": "Upgrade your business travel with our corporate Innova Crysta cab service in Pune. Designed for executives, teams, and client pickups, we offer clean, air-conditioned vehicles, uniformed chauffeurs, and punctual service tailored for professional needs."
  },
  {
    "name": "Airport Transfer Innova Crysta Pune",
    "description": "Ensure hassle-free travel to or from Pune Airport with our Innova Crysta airport transfer service. Available 24/7, our cab service includes timely pickups, comfortable seating for up to 6 passengers, and smooth rides with professional drivers."
  },
  {
    "name": "Comfortable Innova Crysta Pune",
    "description": "Our Innova Crysta rentals in Pune are known for exceptional comfort. Featuring captain seats, spacious interiors, rear AC vents, and smooth suspension, this vehicle is ideal for long journeys, senior-friendly travel, and daily use with a touch of luxury."
  }
],
"tableData": [
  ["Innova Crysta Cabs Pune", "Innova Crysta Taxi Service Pune"],
  ["Affordable Innova Crysta Pune", "Chauffeur Driven Innova Crysta Pune"],
  ["Online Booking Innova Crysta Pune", "Family Innova Crysta Taxi Pune"],
  ["Corporate Innova Crysta Cab Pune", "Airport Transfer Innova Crysta Pune"],
  ["Comfortable Innova Crysta Pune", ""]
],



"whychoose": [
    {
        "WhyChooseheading": "Premium Innova Crysta Cabs in Pune",
        "WhyChoosedescription": "Enjoy the comfort and elegance of Innova Crysta cabs in Pune, ideal for local travel, outstation trips, airport transfers, business travel, and family outings. Our service combines luxury with convenience for a truly premium experience."
    },
    {
        "WhyChooseheading": "Spacious and Luxurious Interiors",
        "WhyChoosedescription": "With seating for up to 6–7 passengers, plush seats, air-conditioning, and ample legroom, Innova Crysta is the perfect choice for those who prioritize comfort. Whether you're traveling short or long distances, it ensures a smooth and relaxing journey."
    },
    {
        "WhyChooseheading": "Professional and Courteous Drivers",
        "WhyChoosedescription": "Our drivers are experienced, well-trained, and familiar with city routes and outstation highways. They follow all safety norms, maintain punctuality, and offer courteous service, ensuring a secure and pleasant travel experience."
    },
    {
        "WhyChooseheading": "Versatile Use for All Travel Needs",
        "WhyChoosedescription": "Whether it's a corporate ride, airport pickup/drop, weekend trip, pilgrimage, or wedding transport, our Innova Crysta fleet is suited for every occasion. Customize your ride as per your requirements with flexible rental durations."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "We maintain our vehicles in top condition with regular servicing and deep cleaning before every ride. Expect a hygienic, fresh, and mechanically sound vehicle every time you book."
    },
    {
        "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
        "WhyChoosedescription": "Our fare structure is clear and upfront—covering tolls, taxes, fuel, and driver charges. You get the best-in-class service without worrying about extra or hidden costs."
    },
    {
        "WhyChooseheading": "Perfect for Group Travel and Family Trips",
        "WhyChoosedescription": "Innova Crysta’s spacious design makes it ideal for group or family travel, offering the comfort and roominess needed for everyone to travel together without compromise."
    },
    {
        "WhyChooseheading": "24/7 Booking Support and Easy Online Reservations",
        "WhyChoosedescription": "Book your Innova Crysta cab anytime through our website or customer support helpline. We’re available 24/7 to assist with quick bookings, changes, or custom requests for your convenience."
    }
]



























    }

const faqData = [
    {
        question: "How do I book an Innova Crysta cab in Pune?",
        answer: "You can book your Innova Crysta by calling Meghana Cab at +91 9075462128 or through our website for easy online booking."
    },
    {
        question: "What types of trips can I use an Innova Crysta for in Pune?",
        answer: "Innova Crysta cabs are available for local travel, airport transfers, outstation trips, corporate travel, and Pune Darshan."
    },
    {
        question: "How many people can travel in an Innova Crysta?",
        answer: "An Innova Crysta can comfortably accommodate 6 to 7 passengers along with luggage."
    },
    {
        question: "Are your Innova Crysta cabs available 24/7 in Pune?",
        answer: "Yes, our services are available round-the-clock to meet your travel needs at any time."
    },
    {
        question: "Is the Innova Crysta suitable for outstation travel from Pune?",
        answer: "Absolutely. It’s one of the most preferred vehicles for long-distance travel due to its comfort and reliability."
    },
    {
        question: "Are the vehicles well-maintained and clean?",
        answer: "Yes, all our cabs are regularly maintained, cleaned, and sanitized before every trip to ensure your safety and comfort."
    },
    {
        question: "What is included in the fare for Innova Crysta cab service?",
        answer: "The fare includes driver charges, fuel, and tolls. Additional charges may apply for waiting time or parking."
    },
    {
        question: "Can I book the Innova Crysta for a day or hourly basis?",
        answer: "Yes, we offer hourly rentals and full-day packages based on your specific needs."
    },
    {
        question: "Do you provide airport pickup and drop in Innova Crysta?",
        answer: "Yes, we provide punctual and comfortable airport pickup and drop services in Pune using Innova Crysta."
    },
    {
        question: "What payment methods are available?",
        answer: "We accept UPI, debit/credit cards, net banking, and cash payments."
    },
];

const testimonialsData = [
    {
        name: 'Mr. Ashish Pawar',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Booked an Innova Crysta in Pune for our outstation trip. Spacious, smooth ride and excellent service from Meghana Cab.”',
    },
    {
        name: 'Ms. Kavita Shah',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“Very professional service. The Innova Crysta was clean and the driver was polite and punctual. Highly recommended.”',
    },
];
















































































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];










const innovaCrystaPuneSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Innova Crysta Cabs in Pune",
  "description": "Affordable and chauffeur-driven Innova Crysta taxi service in Pune. Perfect for family trips, corporate travel, airport transfers, and comfortable city rides.",
  "provider": {
    "@type": "Organization",
    "name": "Meghana Cabs",
    "url": "https://www.meghanacabs.com"
  },
  "serviceType": "Taxi Service",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/innova-crysta-cabs-pune"
  }
};





    return (
        <div>


<Helmet>
  <title>Innova Crysta Cabs in Pune | Affordable Taxi Service</title>
  <meta
    name="description"
    content="Book affordable and chauffeur-driven Innova Crysta cabs in Pune for family trips, corporate travel, airport transfers, and comfortable city rides."
  />
  <meta
    name="keywords"
    content="Innova Crysta Cabs Pune, Innova Crysta Taxi Service Pune, Affordable Innova Crysta Pune, Chauffeur Driven Innova Crysta Pune, Online Booking Innova Crysta Pune, Family Innova Crysta Taxi Pune, Corporate Innova Crysta Cab Pune, Airport Transfer Innova Crysta Pune, Comfortable Innova Crysta Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(innovaCrystaPuneSchema)}
  </script>
</Helmet>

            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/Keywords/39.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Innovacrystacabsinpune;